import React, { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { FaEye } from "react-icons/fa";
import OrderFilters from "../../../Components/Orders/OrderFilters";
import { Link } from "react-router-dom";

const Orders = () => {
  const token = Cookies.get("token");

  const [orders, setOrders] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);

  const [filters, setFilters] = useState({
    search: "",
    status: "",
    product_id: "",
  });

  const [selectedOrder, setSelectedOrder] = useState<any>(null);
  const [showDetail, setShowDetail] = useState(false);

  const formatPrice = (price: any) => {
    return new Intl.NumberFormat("id-ID").format(price);
  };

  const fetchOrders = async (page = 1) => {
    setLoading(true);

    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/orders`, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          page,
          search: filters.search,
          status: filters.status,
          product_id: filters.product_id,
        },
      });

      setOrders(res.data.data);
      setCurrentPage(res.data.current_page);
      setLastPage(res.data.last_page);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, [filters]);

  return (
    <div className="mt-7">
      <div className="flex flex-col md:flex-row justify-between gap-4 mb-6">
        <h2 className="text-xl font-bold text-gray-800">Manajemen Order</h2>

        {/* FILTER */}
        <OrderFilters filters={filters} setFilters={setFilters} />
      </div>

      {/* TABLE */}

      <div className="bg-white rounded-xl shadow border overflow-x-auto mt-5">
        <table className="min-w-full text-sm">
          <thead className="bg-gray-100">
            <tr>
              <th className="p-3 text-left">Produk</th>
              <th className="p-3 text-left">Nama</th>
              <th className="p-3 text-left">Qty</th>
              <th className="p-3 text-left">Total</th>
              <th className="p-3 text-left">Tanggal</th>
              <th className="p-3 text-left">Status</th>
              <th className="p-3 text-left">Aksi</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan={7} className="text-center p-10">
                  Loading...
                </td>
              </tr>
            ) : orders.length > 0 ? (
              orders.map((order) => (
                <tr key={order.id} className="border-t">
                  <td className="p-3 flex gap-3 items-center">
                    {/* <img src={`${process.env.REACT_APP_STORAGE_URL}/products/${order.product?.images?.[0]?.image}`} className="w-14 h-14 object-cover rounded" alt="" /> */}

                    <div>
                      {/* <p className="font-semibold">{order.product?.product_code}</p> */}
                      <p className=" text-gray-500">{order.product?.name}</p>
                    </div>
                  </td>

                  <td className="p-3">{order.name}</td>
                  <td className="p-3">{order.quantity}</td>
                  <td className="p-3">Rp {formatPrice(order.total_price)}</td>
                  <td className="p-3">
                    {new Date(order.created_at).toLocaleString("id-ID", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </td>

                  <td className="p-3">
                    {order.status === "paid" ? <span className="bg-green-100 text-green-600 px-2 py-1 rounded text-xs">Paid</span> : <span className="bg-yellow-100 text-yellow-600 px-2 py-1 rounded text-xs">Pending</span>}
                  </td>

                  <td className=" flex gap-3 -mt-3">
                    <div
                      onClick={() => {
                        setSelectedOrder(order);
                        setShowDetail(true);
                      }}
                      className="text-blue-500 -mt-3">
                      <FaEye size={20} />
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={7} className="text-center p-10">
                  Tidak ada data
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* PAGINATION */}

      <div className="flex justify-end gap-3 mt-5">
        <button disabled={currentPage === 1} onClick={() => fetchOrders(currentPage - 1)} className="px-4 py-2 bg-gray-200 rounded">
          Prev
        </button>

        <span>
          {currentPage} / {lastPage}
        </span>

        <button disabled={currentPage === lastPage} onClick={() => fetchOrders(currentPage + 1)} className="px-4 py-2 bg-gray-200 rounded">
          Next
        </button>
      </div>

      {/* DETAIL MODAL */}

      {showDetail && selectedOrder && (
        <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50">
          <div className="bg-white rounded-2xl shadow-xl w-[520px] overflow-hidden">
            {/* HEADER */}
            <div className="bg-primary text-white px-6 py-4">
              <h2 className="text-lg font-semibold">Detail Order</h2>
              <p className="text-sm opacity-80">{selectedOrder.order_code}</p>
            </div>

            {/* CONTENT */}
            <div className="p-6 space-y-5">
              {/* CUSTOMER */}
              <div className="border rounded-xl p-4">
                <h3 className="font-semibold mb-3 text-gray-700">Informasi Customer</h3>

                <div className="grid grid-cols-2 gap-3 text-sm">
                  <div>
                    <p className="text-gray-500">Nama</p>
                    <p className="font-medium">{selectedOrder.name}</p>
                  </div>

                  <div>
                    <p className="text-gray-500">Email</p>
                    <p className="font-medium">{selectedOrder.email}</p>
                  </div>

                  <div>
                    <p className="text-gray-500">Phone</p>

                    <Link to={`https://wa.me/${selectedOrder.phone}`} target="_blank" className="text-green-600 font-medium hover:underline">
                      {selectedOrder.phone}
                    </Link>
                  </div>

                  <div>
                    <p className="text-gray-500">Quantity</p>
                    <p className="font-medium">{selectedOrder.quantity}</p>
                  </div>
                </div>

                <div className="mt-3">
                  <p className="text-gray-500 text-sm">Alamat</p>
                  <p className="font-medium text-sm">{selectedOrder.address}</p>
                </div>
              </div>

              {/* ORDER INFO */}
              <div className="border rounded-xl p-4">
                <h3 className="font-semibold mb-3 text-gray-700">Informasi Order</h3>

                <div className="flex justify-between items-center">
                  <div>
                    <p className="text-gray-500 text-sm">Status</p>

                    {selectedOrder.status === "paid" ? <span className="bg-green-100 text-green-600 px-3 py-1 rounded text-xs">Paid</span> : <span className="bg-yellow-100 text-yellow-600 px-3 py-1 rounded text-xs">Pending</span>}
                  </div>

                  <div className="text-right">
                    <p className="text-gray-500 text-sm">Total Harga</p>
                    <p className="text-xl font-bold text-primary">Rp {formatPrice(selectedOrder.total_price)}</p>
                  </div>
                </div>
              </div>
            </div>

            {/* FOOTER */}
            <div className="px-6 py-4 border-t flex justify-end">
              <button onClick={() => setShowDetail(false)} className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300">
                Tutup
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Orders;
